import React from 'react';
import moment from 'moment';
import { faEye, faFileAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

//Componente
import { showMessage } from 'helpers/message';

//Helpers
import { abrirPDF } from '../../helpers/abrirPDF';

export default function Documentos({ documentos = [], onChangeDocumentos = () => { }, state, disabledCampos = false }) {
    const handleFileChange = (e, documento) => {
        if (!e.target.files[0].type.startsWith("application/pdf")) {
            showMessage(
                "Aviso",
                "Apenas arquivos no formato PDF é permitido. Por favor, selecione um arquivo válido.",
                "warning",
                null
            );
            return;
        }

        const FR = new FileReader();

        FR.addEventListener("load", function (evt) {
            let base64 = evt.target.result.split(",")[1];
            onChangeDocumentos({
                tbDocumentos_Id: documento.id,
                descricao: documento.descricao,
                identificacao: documento.identificacao,
                arquivo: base64,
                dataImportacao: moment().format("YYYY-MM-DD HH:mm:ss")
            })
        });

        FR.readAsDataURL(e.target.files[0]);
    };

    return (
        <div className="container mb-3">
            {documentos.map((documento, index) => (
                <div key={index} className="card mb-3 shadow">
                    <div className="row g-0 align-items-center">
                        <div className="col-auto d-flex flex-column align-items-center p-3">
                            <div className="d-flex align-items-center" style={{ cursor: 'pointer' }}>
                                <label htmlFor={`file-upload-${index}`} className="mb-0" style={{ cursor: "pointer" }}>
                                    <FontAwesomeIcon icon={faFileAlt} className={`${state?.documentos?.some(doc => doc.tbDocumentos_Id === documento.id) ? "text-success" : "text-secondary"} mb-2`} size="4x" />
                                </label>
                                <input
                                    id={`file-upload-${index}`}
                                    type="file"
                                    accept="application/pdf"
                                    style={{ display: 'none' }}
                                    onChange={(e) => {
                                        if(disabledCampos){
                                            showMessage(
                                                "Aviso",
                                                "Não é permitido alterar ou adicionar documento para essa categoria",
                                                "warning",
                                                null
                                            );
                                            return;
                                        }else {
                                            handleFileChange(e, documento)
                                        }
                                    }}
                                />
                            </div>
                            {state?.documentos?.some(doc => doc.tbDocumentos_Id === documento.id) &&
                                <button className="btn btn-primary btn-sm mt-2" onClick={() => {
                                    let anexo = state?.documentos?.filter(doc => doc.tbDocumentos_Id === documento.id)[0].arquivo;
                                    if (anexo?.includes(".pdf"))
                                        window.open(anexo, "_blank")
                                    else
                                        abrirPDF(anexo)
                                }}>
                                    <FontAwesomeIcon icon={faEye} /> Visualizar
                                </button>}
                        </div>
                        <div className="col">
                            <div className="card-body" style={{ color: "#666" }}>
                                <div className="d-flex align-items-center">
                                    <h3 className="mb-0">{documento.identificacao}</h3>
                                    {documento.obrigatorio && (
                                        <span className="badge bg-danger text-white ms-3">
                                            Obrigatório
                                        </span>
                                    )}
                                </div>
                                <p>
                                    <span className="fw-bold">Descrição: </span> {documento.descricao}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}
